// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logistic-project {
  margin-top: 30px;
}
@media (max-width: 490px) {
  .logistic-project {
    margin-top: 20px;
  }
}
.logistic-project__date {
  margin-bottom: 80px;
}
@media (max-width: 490px) {
  .logistic-project__date {
    margin-bottom: 50px;
  }
}
.logistic-project__date-number {
  font-size: 22px;
  color: #000000;
  font-weight: 700;
  margin-right: 15px;
}
@media (max-width: 490px) {
  .logistic-project__date-number {
    font-size: 16px;
    margin-right: 7px;
  }
}
.logistic-project__date-number .dayWeek {
  font-size: 20px;
  color: #808080;
  font-weight: 400;
}
@media (max-width: 490px) {
  .logistic-project__date-number .dayWeek {
    font-size: 16px;
  }
}
.logistic-project__top {
  display: flex;
}
.logistic-project__project {
  font-size: 20px;
  color: #000000;
  font-weight: 700;
  margin-right: 15px;
}
@media (max-width: 490px) {
  .logistic-project__project {
    font-size: 16px;
    margin-right: 7px;
    width: 270px;
  }
}
.logistic-project__region {
  font-size: 20px;
  color: #000000;
  font-weight: 500;
}
.logistic-project__table {
  width: 750px;
  table-layout: fixed;
  margin-top: 10px;
}
@media (max-width: 490px) {
  .logistic-project__table {
    width: 360px;
    table-layout: auto;
  }
}
.logistic-project__table__td {
  width: 175px;
}
@media (max-width: 490px) {
  .logistic-project__table__td {
    width: 140px;
  }
}
.logistic-project__button {
  width: 120px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
@media (max-width: 460px) {
  .logistic-project__button {
    width: 90px;
    height: 20px;
    font-size: 10px;
    margin-right: 5px;
  }
}

.pickap-logistic__item {
  margin-bottom: 25px;
  text-align: left;
  color: #000000;
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
}
.pickap-logistic__item-supplier {
  font-size: 21px;
  font-weight: 700;
}
.pickap-logistic__unloading {
  margin-top: 25px;
}
.pickap-logistic__unloading-title {
  font-size: 22px;
  color: #000000;
  font-weight: 600;
  text-align-last: left;
}
.pickap-logistic__unloading-items {
  text-align: left;
  color: #000000;
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
  margin-top: 15px;
  margin-bottom: 15px;
}
.pickap-logistic__unloading-project {
  font-size: 21px;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/components/Logistics/style.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;AAAI;EAFJ;IAGQ,gBAAA;EAGN;AACF;AADI;EACI,mBAAA;AAGR;AAFQ;EAFJ;IAGQ,mBAAA;EAKV;AACF;AAJQ;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAMZ;AALY;EALJ;IAMQ,eAAA;IACA,iBAAA;EAQd;AACF;AANY;EACI,eAAA;EACA,cAAA;EACA,gBAAA;AAQhB;AAPgB;EAJJ;IAKI,eAAA;EAUd;AACF;AAJI;EACI,aAAA;AAMR;AAJI;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAMR;AALQ;EALJ;IAMQ,eAAA;IACA,iBAAA;IACA,YAAA;EAQV;AACF;AALI;EACI,eAAA;EACA,cAAA;EACA,gBAAA;AAOR;AAJI;EACI,YAAA;EACA,mBAAA;EACA,gBAAA;AAMR;AALQ;EAJJ;IAKQ,YAAA;IACA,kBAAA;EAQV;AACF;AANQ;EACI,YAAA;AAQZ;AAPY;EAFJ;IAGQ,YAAA;EAUd;AACF;AALI;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAOR;AALQ;EAXJ;IAYQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAQV;AACF;;AAAI;EACI,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAGR;AADQ;EACI,eAAA;EACA,gBAAA;AAGZ;AAEI;EACI,gBAAA;AAAR;AAEQ;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AAAZ;AAGQ;EACI,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AADZ;AAIQ;EACI,eAAA;EACA,gBAAA;AAFZ","sourcesContent":[".logistic-project {\n    margin-top: 30px;\n    @media(max-width: 490px) {\n        margin-top: 20px;\n    }\n\n    &__date {\n        margin-bottom: 80px;\n        @media(max-width: 490px) {\n            margin-bottom: 50px;\n    }\n        &-number {\n            font-size: 22px;\n            color: #000000;\n            font-weight: 700;\n            margin-right: 15px;\n            @media(max-width: 490px) {\n                font-size: 16px;\n                margin-right: 7px;\n            }\n\n            .dayWeek {\n                font-size: 20px;\n                color:  #808080;\n                font-weight: 400;\n                @media(max-width: 490px) {\n                font-size: 16px;\n            }\n            }\n        }\n    }\n\n\n    &__top {\n        display: flex;\n    }\n    &__project {\n        font-size: 20px;\n        color: #000000;\n        font-weight: 700;\n        margin-right: 15px;\n        @media(max-width: 490px) {\n            font-size: 16px;\n            margin-right: 7px;\n            width: 270px;\n        }\n    }\n\n    &__region {\n        font-size: 20px;\n        color: #000000;\n        font-weight: 500;\n    }\n\n    &__table {\n        width: 750px;\n        table-layout: fixed;\n        margin-top: 10px;\n        @media(max-width: 490px) {\n            width: 360px;\n            table-layout: auto;\n        }\n\n        &__td {\n            width: 175px;\n            @media(max-width: 490px) {\n                width: 140px;\n            }\n            \n        }\n    }\n\n    &__button {\n        width: 120px;\n        height: 30px;\n        border: 1px solid #212529;\n        background-color: #212529;\n        color: #ffffff;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 14px;\n        \n        @media(max-width: 460px) {\n            width: 90px;\n            height: 20px;\n            font-size: 10px;\n            margin-right: 5px;\n        }\n    }\n\n\n}\n\n//pickap logistic \n.pickap-logistic {\n    &__item {\n        margin-bottom: 25px;\n        text-align: left;\n        color: #000000;\n        font-size: 16px;\n        font-weight: 400;\n        line-height: normal;\n\n        &-supplier {\n            font-size: 21px;\n            font-weight: 700;\n        }\n    }\n\n    //выгрузка материалов\n    &__unloading {\n        margin-top: 25px;\n\n        &-title {\n            font-size: 22px;\n            color: #000000;\n            font-weight: 600;\n            text-align-last: left;\n        }\n\n        &-items {\n            text-align: left;\n            color: #000000;\n            font-size: 16px;\n            font-weight: 400;\n            line-height: normal;\n            margin-top: 15px;\n            margin-bottom: 15px;\n        }\n\n        &-project {\n            font-size: 21px;\n            font-weight: 700;\n        }\n    } \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
